// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { socialLinksStyles } from "@awc/Overrides/Widgets/Basic/SocialLinks";
import { color, getSystemColor } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { StyledIcon, StyledTypography } from "@insite/mobius/Link";
import { css } from "styled-components";

socialLinksStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        column-gap: 9px;
    `,
};

socialLinksStyles.linkWrapper = {
    css: css`
        flex-shrink: 0;
        display: flex; // center all the links
        justify-content: center; // center all the links
        word-break: normal; // allows links to wrap responsively
        flex-grow: 0; // leave space on the sides
        gap: 14px;
        flex-wrap: wrap;
        flex-basis: auto;
    `,
};

socialLinksStyles.link = {
    hoverStyle: {
        color: getSystemColor("common.ui28"),
    },
    typographyProps: {
        color: "common.white",
        css: css`
            &&& {
                color: ${color("common.white")};
                margin-left: 12px;
                &:empty {
                    display: none;
                }
            }
        `,
    },
    css: css`
        display: flex;
        ${IconWrapper} {
            margin: 0;
        }
        &:focus {
            ${StyledIcon}, ${StyledTypography} {
                color: ${color("common.ui28")};
            }
        }
    `,
};
